import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

enum AddToListActionType {
    Click = "click",
    Hover = "hover",
}

export default function createAccountReviewTrackingService(track: TrackFn) {
    const trackAddToList = (action: AddToListActionType, eventName: string) => {
        track("add to list", action, eventName);
    };

    const trackAddToListButtonAction = (action: AddToListActionType, listsCount: number = 0) => {
        const status = listsCount > 0 ? "already in a list" : "not in a list";

        const params: Array<string | number> = ["add to list", status];

        if (listsCount > 0) {
            params.push(listsCount);
        }

        trackAddToList(action, createTrackingEventName(...params));
    };

    return {
        trackAddToListClick(listsCount?: number) {
            trackAddToListButtonAction(AddToListActionType.Click, listsCount);
        },
        trackAddToListHover(listsCount?: number) {
            trackAddToListButtonAction(AddToListActionType.Hover, listsCount);
        },
        trackAddToListSelect(type: string) {
            trackAddToList(AddToListActionType.Click, type);
        },
    };
}
